<template>
  <!-- 课程信息 -->
  <div :class="[isH5 ? 'mobile-course-card' : 'pc-course-card', 'joint-course-card']">
    <img
      class="cover"
      :src="handleImageUrl(couseInfo.cover_url) + '?imageView2/0/w/260'"
      alt="课程图片"
    />
    <div class="item-right">
      <p class="title">
        {{ couseInfo.course_name }}
      </p>
      <p class="course-info">
        <span class="lesson-num">{{ couseInfo.lesson_count }}课时</span>
        <span class="price"><i>￥</i>{{ couseInfo.price / 100 }}</span>
      </p>
    </div>
  </div>
</template>

<script>
import { handleImageUrl } from "@saas/components/src";
export default {
  props: {
    isH5: {
      type: Boolean,
      default: false,
    },
    couseInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data: function () {
    return {
      handleImageUrl,
    };
  },
};
</script>

<style lang="scss" scoped>
.pc-course-card {
  --joint-course-title: var(--mg-text-primary);
  --joint-course-secondary: var(--mg-text-secondary);

  html.dark & {
    --joint-course-title: var(--mg-text-primary);
    --joint-course-secondary: var(--mg-text-secondary);
  }

  width: 100%;
  display: flex;
  align-items: center;
  margin-right: 0;
  cursor: pointer;
  .cover {
    width: 120px;
    height: 66px;
    object-fit: cover;
    border-radius: 4px;
    margin-right: 10px;
  }
  .item-right {
    flex: 1;
    width: 0;
    height: 66px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .title {
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 14px;
      color: var(--joint-course-title);
      line-height: 20px;
    }
    .course-info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .lesson-num {
        font-size: 10px;
        color: var(--joint-course-secondary);
        line-height: 12px;
      }
      .price {
        i {
          font-style: normal;
          font-size: 12px;
        }
        font-size: 18px;
        color: $activity-color;
      }
    }
  }
}
.mobile-course-card {
  --joint-course-title: var(--mg-text-primary);
  --joint-course-secondary: var(--mg-text-secondary);

  html.dark & {
    --joint-course-title: var(--mg-text-primary);
    --joint-course-secondary: var(--mg-text-secondary);
  }

  width: 100%;
  display: flex;
  align-items: center;
  margin-right: 0;
  .cover {
    width: 3.2rem;
    height: 1.76rem;
    object-fit: cover;
    border-radius: 4px;
    margin-right: 0.27rem;
  }
  .item-right {
    flex: 1;
    width: 0;
    height: 1.76rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .title {
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 0.37rem;
      color: var(--joint-course-title);
      line-height: 0.53rem;
    }
    .course-info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .lesson-num {
        font-size: 0.27rem;
        color: var(--joint-course-secondary);
        line-height: 0.32rem;
      }
      .price {
        i {
          font-style: normal;
          font-size: 0.32rem;
        }
        font-size: 0.48rem;
        color: $activity-color;
      }
    }
  }
}

</style>
